//#region libraries
import React, { useEffect } from 'react';

// bootstrap
import { Col, Form, Row } from 'react-bootstrap';

// custom components
import { NewScreen, Title as CustomTitle, SearchBar } from '_atoms';
import { TransactionsList } from '_organisms';

// tremor
import { DateRangePicker } from '@tremor/react';

//redux
import { useDispatch, useSelector } from 'react-redux';
import { selectSelectedReward } from "_redux/slices/prm-club/rewards"
import { setSelectedPurchasesOption, selectPurchasesOption, selectDataRange, setSelectedRangeDate, setSearchValue, selectSearchValue } from '_redux/slices/marketplace/transaction';
//#endregion

const statusOptions = [
    { label: "Select a status", value: "ALL" },
    { label: "Approved", value: "approved" },
    { label: "Cancelled", value: "cancelled" },
    { label: "Completed", value: "complete" },
    { label: "Payment complete", value: "payment-complete" },
    { label: "Payment failed", value: "payment-failed" },
    { label: "Pending", value: "pending" },
    { label: "Success", value: "succeeded" },
];

const ProductInformation = () => {

    //#region redux
    const dispatch = useDispatch();
    const dateRange = useSelector(selectDataRange);
    const purchaseOption = useSelector(selectPurchasesOption);
    const selectedProduct = useSelector(selectSelectedReward);
    const searchedValue = useSelector(selectSearchValue)
    //#endregion

    useEffect(() => {
        dispatch(setSearchValue(""))
    }, [])

    //this function fix invalid date of date range picker after refresh
    const normalizeDateRange = (range) => {
        return [
            new Date(range[0]),
            new Date(range[1])
        ];
    };


    return (
        <NewScreen >

            {/* Titles */}
            <Row>
                <Col>
                    <CustomTitle subtitle={"Transactions List"} description={`List all transactions of ${selectedProduct ? selectedProduct.productTitle : "product"}`} />
                </Col>
            </Row>

            {/* analytics / edit toggle */}
            <Row className='mt-3'>

                {/* SearchBar */}
                <Col xs={3}>
                    <SearchBar onChange={e => dispatch(setSearchValue(e.target.value))} transaction={true} placeholder={`Search pax ...`} value={searchedValue} />
                </Col>

                {/* STATUS tabs */}
                <Col xs={3}>
                    <Form.Select aria-label="Floating label select example" onChange={(e) => dispatch(setSelectedPurchasesOption(e.target.value))} name='purchaseTab' value={purchaseOption} >
                        {statusOptions.map((option => {
                            return <option key={option.value} value={option.value} > {option.label}</option>  // Add your logic here to fetch the data from the API based on the selected option.
                        }))}
                    </Form.Select>
                </Col>

                {/*Date Picker, last month*/}
                <Col>
                    <DateRangePicker
                        onValueChange={(value) => { dispatch(setSelectedRangeDate(value)) }}
                        value={(dateRange)}
                        enableDropdown={true}
                        maxWidth="max-w-lg"
                        dropdownPlaceholder={'Last 7 Days'}
                    />
                </Col>
            </Row>
            {/* transation list */}
            <Row className='mt-3'>
                <Col>
                    <TransactionsList dateRange={dateRange} />
                </Col>
            </Row>

        </NewScreen>
    );
};

export default ProductInformation;
